import angular from 'angular';

export default angular.module('cms.grid.param-converter', [])
    .factory('GridParamsConverter', function(){

        return {

            /**
             *
             * @param {Object} params Ag-Grid get parameters
             * @param {number} params.startRow
             * @param {number} params.endRow
             * @param {*} params.sortModel
             * @param {*} params.filterModel
             * @param {string} params.context
             * @param {function} params.successCallback successCallback(rowsThisBlock, lastRow)
             * @param {function} params.failCallback failCallback(reason)
             * @returns {*} cmsApiParams Cms api parameters model
             */
            getCmsApiParams: function(params){
                let limit = params.endRow - params.startRow;
                let page = Math.floor(params.startRow/limit) + 1;
                let queryParams = {limit, page};
                Object.keys(params.filterModel).forEach(function (paramName) {
                    let filterModel = params.filterModel[paramName];
                    if (filterModel.filterType === "date" && filterModel.type === "inRange") {
                        queryParams[paramName + 'After'] = filterModel.dateFrom;
                        queryParams[paramName + 'Before'] = filterModel.dateTo;
                    } else
                        queryParams[paramName] = filterModel.filter
                });

                if(params.sortModel.length) {
                    let order = params.sortModel[0];
                    queryParams.order_by = order.colId;
                    queryParams.order_direction = order.sort;
                }

                return queryParams;
            }
        }
    })
    .name


// WEBPACK FOOTER //
// ./src/cmsCore/Grid/GridParamsConverter.js